import { render, staticRenderFns } from "./permissionTree.vue?vue&type=template&id=b9f8b07a&"
import script from "./permissionTree.vue?vue&type=script&lang=js&"
export * from "./permissionTree.vue?vue&type=script&lang=js&"
import style0 from "./permissionTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports